module.exports = __webpack_public_path__ + "img/banner2.0e0d590b.webp";